import { useEffect } from "react";
import { useChat } from "../../context/chatContext";
import ChatBody from "../common/chat/chatBody";

const Chat = ({ useCase }: { useCase?: number }) => {
	const { setShowCards, startChat, renderFromHistory } = useChat();

	useEffect(() => {
		if (useCase !== undefined) {
			if (!renderFromHistory) {
				startChat(useCase);
			}
			setShowCards(false);
		} else {
			setShowCards(true);
		}
	}, [useCase]);

	return (
		<>
			<ChatBody useCase={useCase} />
		</>
	);
};

export default Chat;
